import { XCircle, CheckCircle, FileText, CircleDashed, DollarSign } from "lucide-react";
import { EstimateStatus } from "@rebuild/shared";
import type { ReactNode } from "react";
import type { SelectFieldOptions } from "@/components/estimation-details/details-section/GeneralDetails/Field";

// Icon mapping for different status types
export const statusIconMap: Record<string, ReactNode> = {
  Approved: <CheckCircle className="h-4 w-4 text-green-500" />,
  Paid: <DollarSign className="h-4 w-4 text-green-700" />,
  Closed: <XCircle className="h-4 w-4 text-red-500" />,
  "In Progress": <img src="/in-progress.svg" />,
  "In progress": <img src="/in-progress.svg" />,
  "Waiting on Information": <XCircle className="h-4 w-4 text-gray-500" />,
  "Waiting on information": <XCircle className="h-4 w-4 text-gray-500" />,
  Received: <CircleDashed className="h-4 w-4 text-gray-400" />,
  "Under Review": <FileText className="h-4 w-4 text-blue-500" />,
  "Under review": <FileText className="h-4 w-4 text-blue-500" />,
  "Final Review": <CheckCircle className="h-4 w-4 text-purple-500" />,
  "Final review": <CheckCircle className="h-4 w-4 text-purple-500" />,
  All: <></>,
  "": <></>,
};

// Default hardcoded status options
export const defaultStatusOptions: SelectFieldOptions[] = [
  {
    value: EstimateStatus.APPROVED,
    label: "Approved",
    icon: statusIconMap["Approved"],
  },
  {
    value: EstimateStatus.PAID,
    label: "Paid",
    icon: statusIconMap["Paid"],
  },
  {
    value: EstimateStatus.CLOSED,
    label: "Closed",
    icon: statusIconMap["Closed"],
  },
  {
    value: EstimateStatus.IN_PROGRESS,
    label: "In Progress",
    icon: statusIconMap["In Progress"],
  },
  {
    value: EstimateStatus.WAITING_ON_INFORMATION,
    label: "Waiting on Information",
    icon: statusIconMap["Waiting on Information"],
  },
  {
    value: EstimateStatus.RECEIVED,
    label: "Received",
    icon: statusIconMap["Received"],
  },
  {
    value: EstimateStatus.UNDER_REVIEW,
    label: "Under Review",
    icon: statusIconMap["Under Review"],
  },
  {
    value: EstimateStatus.FINAL_REVIEW,
    label: "Final Review",
    icon: statusIconMap["Final Review"],
  },
];

// Helper function to get icon for a status
export const getStatusIcon = (status: EstimateStatus): ReactNode => {
  if (statusIconMap[status]) {
    // If we have a predefined icon for this status name
    return statusIconMap[status];
  } else {
    // Default icon for custom statuses without predefined icons
    return <CircleDashed className="h-4 w-4 text-gray-400" />;
  }
};
